
import { TheAboutStep, TheLoader, TheNumberInUse } from "./components/index";
import {
  TheIdentifier,
  TheCode,
  TheEmail,
  Welcome,
  TheConsent,
} from "../../../Common/CommonSteps";
import AppSvc from "../../../../services/app-svc";
import { AppEventbus } from "../../../../services/app-svc";

let service = null;

export default {
  name: "oauth",
  components: {
    TheAboutStep,
    TheIdentifier,
    TheCode,
    TheEmail,
    Welcome,
    TheConsent,
    TheLoader,
    TheNumberInUse
  },
  props: {
    apiUrl: {
      required: true,
      default: "",
    },
    user: {
      required: false,
      default: null,
    },
    salons: {
      required: false,
      default: [],
    },
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    useAxios: Boolean,
    oauthUrl: {
      Type: String,
      required: true,
    },
    layout: {
      type: String,
      default: "chain",
      required: false,
    },
    initialCreateStep: {
      type: String,
      default: "loading",
      required: false,
    },

    isProfile: {
      required: false,
      default: false,
      type: Boolean,
    },
    oauthData: {
      required: false,
      default: null,
    }
  },
  data() {
    return {
      state: {
        LOADING: 'loading',
        EMAIL_CODE: "verify-email",
        ABOUT: "insert-userdata",
        SMS_CODE: "verify-sms",
        CONSENT: "consent",
        WELCOME: "welcome-screen",
        NUMBER_IN_USE: "number-in-use"
      },
      currentForm: "loading",
      previousStep: "loading",
      loading: false,
      tempUser: null,
      error: "",
      showResendText: false,
      params: {
        username: "",
        password: "",
        mobile: "",
        firstName: "",
        lastName: "",
        code: "",
        ecode: "",
        step: "",
        isTpn: "",
        tpnChainId: "",
        tpnSiteId: "",
        clientIdentity: "",
        eclientIdentity: "",
        vippsEmail: ""

      },
    };
  },
  computed: {
    coreApiUrl() {
      return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_CORE_API_URL : this.$config.FIXIT_CORE_API_URL
    },
    origin() {
      return localStorage.getItem('origin') ?? ''
    }
  },
  beforeDestroy() {
    AppEventbus.$off("create-new-oauth-user");
  },
  methods: {
    changeView(state) {
      this.resetError();
      this.$emit("changeView", state);
    },
    goToreviousStep() {
      this.resetError();
      if (this.previousStep != this.currentForm && this.previousStep != 'loading') {
        this.currentForm = this.previousStep
      } else {
        this.$emit("changeView", 'select_screen');
      }
    },
    verifyInputFields() {
      switch (this.currentForm) {
        case "insert-email":
          return this.params["username"] == "";
        case "insert-userdata":
          return (
            this.params["firstName"] == "" ||
            this.params["lastName"] == "" ||
            this.params["mobile"] == ""
          );
        case "create-password":
          return this.params["password"] == "";
        default:
          return false;
      }
    },
    resetError() {
      this.error = "";
    },
    /**
     * PARAMETER SETTERS
     */
    setEmailCode(value) {
      this.error = "";
      this.params["ecode"] = value;
    },
    setMobileCode(value) {
      this.error = "";
      this.params["code"] = value;
    },
    setUserData(value) {
      this.error = "";
      this.params["firstName"] = value.firstName;
      this.params["lastName"] = value.lastName;
      this.params["mobile"] = value.mobile;
    },
    setClientIdentity(value) {
      this.params["clientIdentity"] = value;
    },
    setEClientIdentity(value) {
      this.params["eclientIdentity"] = value;
    },
    setUsername(value) {
      this.error = "";
      this.params["username"] = value;
    },
    setPassword(value) {
      this.params["password"] = value;
    },

    startEmailVerification(value) {
      if (value.data?.nextStep === this.state.EMAIL_CODE) {
        this.setUsername(value.data.fixitNoUser.email);
        this.email = value.data.fixitNoUser.email;
        this.setEClientIdentity(value.data.clientIdentity);
        this.previousStep = this.currentForm;
        this.currentForm = value.data.nextStep;
      } else if (
        (value.data?.nextStep == null ||
          value.data?.nextStep === this.state.WELCOME) &&
        value.data.fixitNoUser != null
      ) {
        this.previousStep = this.currentForm;
        this.currentForm = value.data.nextStep;

        this.$emit("setUser", value.data.fixitNoUser);
      }
    },
    resendCode() {
      var body = {
        username: this.params.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        email: this.email,
        mobile: this.params.mobile,
        resendCode: 'true'
      };

      service
        .VerifyOauthStep(
          `${this.coreApiUrl}/api`,
          body
        )
        .then((response) => {
          this.error = "";
          if (response.data.responseCode == 200) {
            this.showResendText = true;

            var result = response.data;
            this.clientIdentity = result.clientIdentity;
          } else {
            this.error = response.data.responseMessage;
          }
        });
    },
    async VerifyStep(reuseOauthEmail) {
      this.loading = true;
      this.error = "";
      try {
        if (
          [this.state.SMS_CODE, this.state.EMAIL_CODE].includes(
            this.currentForm
          ) ||
          this.$refs.validation.validate()
        ) {
          Object.assign(this.params, { step: this.currentForm });
          if (reuseOauthEmail) Object.assign(this.params, { vippsEmail: this.oauthData.oauthEmail });
          let response = await service.VerifyOauthStep(
            `${this.coreApiUrl}/api`,
            this.params,
            reuseOauthEmail
          );
          if (response.data.responseCode == 200 || response.data.responseCode == 400) {
            if (this.params.customerId && response.data.fixitNoUser != null) {
              var userData = {
                firstName: response.data.fixitNoUser.firstName.trim(),
                lastName: response.data.fixitNoUser.lastName.trim(),
                mobile: response.data.fixitNoUser.mobileNumber.trim(),
              };
              this.tempUser = userData;
            }
            response.data.nextStep == "verify-email"
              ? this.setEClientIdentity(response.data.clientIdentity)
              : response.data.nextStep == "verify-sms"
                ? this.setClientIdentity(response.data.clientIdentity)
                : "";
            this.previousStep = this.currentForm;
            this.currentForm = response.data.nextStep;
            if (response.data.nextStep === "welcome-screen") {
              if (this.origin.includes('Homepages')) {
                if (localStorage.getItem('fullPath')) {
                  var authorizeResponse = await service.Authorize(process.env.VUE_APP_FIXIT_OAUTH_API_URL, localStorage.getItem('fullPath').replace('/', ''))
                  if (localStorage.getItem('returnUrl') && authorizeResponse.data) {
                    const separator = localStorage.getItem('returnUrl').includes('?') ? '&' : '?';
                    const to = `${localStorage.getItem('returnUrl')}${separator}${authorizeResponse.data}&oauthTarget=${this.origin}`;
                    localStorage.removeItem('oauthTarget')
                    localStorage.removeItem('origin')
                    localStorage.removeItem('fullPath')
                    localStorage.removeItem('returnUrl')

                    window.location.href = to
                  }
                }
              } else {

                this.$emit("setUser", response.data.fixitNoUser);
              }
            }
          } else {
            this.showResendText = false;
            this.error = response.data.responseMessage;
          }
        }
      } catch (error) {
        console.log("Verifying step failed: " + error);
      }
      this.loading = false;
    },
    close() {
      this.$emit("close");
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
    Object.assign(this.params, {
      isTpn: this.isTpn.toString(),
      tpnChainId: this.tpnChainId.toString(),
      tpnSiteId: this.tpnSiteId.toString(),
    });
    if (
      this.$route.query.action &&
      this.$route.query.siteId &&
      this.$route.query.customerId
    ) {
      Object.assign(this.params, {
        siteId: this.$route.query.siteId,
        customerId: this.$route.query.customerId,
      });
    }
    if (this.oauthData != null &&
      ((this.oauthData?.nextStep == null ||
        this.oauthData?.nextStep === this.state.WELCOME) &&
        this.oauthData.fixitNoUser != null)
    ) {
      this.currentForm = this.oauthData?.nextStep
      if (this.origin?.includes('Homepages')) {
        if (localStorage.getItem('fullPath')) {
          var authorizeResponse = await service.Authorize(process.env.VUE_APP_FIXIT_OAUTH_API_URL, localStorage.getItem('fullPath').replace('/', ''))
          if (localStorage.getItem('returnUrl') && authorizeResponse.data) {
            const separator = localStorage.getItem('returnUrl').includes('?') ? '&' : '?';

            const to = `${localStorage.getItem('returnUrl')}${separator}${authorizeResponse.data}&oauthTarget=${this.origin}`;

            localStorage.removeItem('oauthTarget')
            localStorage.removeItem('origin')
            localStorage.removeItem('fullPath')
            localStorage.removeItem('returnUrl')

            window.location.href = to
          }
        }
      } else {

        this.$emit("setUser", this.oauthData.fixitNoUser);
      }
    }
    else if (this.oauthData != null) {
      const hasOauthEnum = ![undefined, null].includes(this.oauthData.oauthSourceEnum) && typeof this.oauthData.oauthSourceEnum === 'number' && this.oauthData.oauthSourceEnum >= 0

      this.previousStep = this.currentForm;
      this.currentForm = this.initialCreateStep
      var userData = {
        firstName: this.oauthData.fixitNoUser.firstName?.trim(),
        lastName: this.oauthData.fixitNoUser.lastName?.trim(),
        mobile: this.oauthData.fixitNoUser.mobileNumber?.trim(),
      };
      this.params["vippsEmail"] = hasOauthEnum && this.oauthData.oauthSourceEnum === 0 ? this.oauthData.oauthEmail : ''
      this.tempUser = userData;
      this.previousStep = this.currentForm;
      this.currentForm = this.initialCreateStep
      this.setUsername(hasOauthEnum && this.oauthData.oauthSourceEnum === 0 ? this.oauthData.fixitNoUser.email : this.oauthData.fixitNoUser.mobileNumber != null && this.oauthData.fixitNoUser.mobileNumber.length > 0 ? this.oauthData.fixitNoUser.mobileNumber : this.oauthData.fixitNoUser.email);
      this.email = this.oauthData.fixitNoUser.email;
      this.oauthSourceEnum = (hasOauthEnum && this.oauthData.oauthSourceEnum === 0 ? 'vipps' : this.oauthData.oauthSourceEnum && this.oauthData.oauthSourceEnum === 1 ? 'google' : 'apple');
      this.oauthUserId = this.oauthData.oauthUserId || '';

      Object.assign(this.params, {
        oauthSourceEnum: this.oauthSourceEnum,
        oauthUserId: this.oauthUserId
      });

      this.oauthData.nextStep == "verify-email"
        ? this.setEClientIdentity(this.oauthData.clientIdentity)
        : this.oauthData.nextStep == "verify-sms"
          ? this.setClientIdentity(this.oauthData.clientIdentity)
          : "";
      if (!this.oauthData.fixitNoUser.firstName) {
        this.tempUser ? this.tempUser.firstName = '' : null
      }
      if (!this.oauthData.fixitNoUser.lastName) {
        this.tempUser ? this.tempUser.lastName = '' : null
      }

    }
  },
};
